import $ from "jquery"
import { trace } from "./../shared/helpers.js"



const ScreenCarousel = {
  
  t : false,

  initSlide() {
    console.log("HELLO SLIDE")
    clearTimeout(this.t);
    let $carousel = $(".carousel");
    let duration = $carousel.find(".active .screen-item").data("interval");
    $carousel.carousel('pause');
    this.t = setTimeout(()=>{
      $carousel.carousel('next');
    }, duration);
    trace(duration);
  },

  addEventListeners() {
    $("body").on("slid.bs.carousel", ".carousel", (e)=> {
      this.initSlide();
    });
  },

  init() {
    const screenVert = document.querySelector(".screenvert-full")
    if (screenVert) {
      return
    }
    if ($('html').hasClass("type-screen")) {
      // trace("Hello Screen Carousel HD");
      this.addEventListeners();
      this.initSlide();
    }
  }

}

export default ScreenCarousel;